import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ACCESS_TOKEN_KEY } from '@app/auth/auth.constants';
import { EnvironmentService } from '@app/environments/services/environment.service';
import { WINDOW } from '@app/lib/services/window.service';
import { IOktaToken } from '@app/auth/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    @Inject(WINDOW)
    private readonly window: Window,

    private readonly environmentService: EnvironmentService,
    private readonly httpClient: HttpClient,
  ) {}

   convertOAuthToCookie(accessToken: string): Observable<any> {
    return this.httpClient.post<any>(
      `${ this.environmentService.environment.apiGateway.url }/ocm/ttoc?&TokenLocation=cookie`,
      {
        access_token: accessToken
      },
    );
  }
}
